import Vue from 'vue'

const state = {
  baseUri: '/botw/config/hnContract/'
}
const getters = {
}
const actions = {
  codes: function (_context, [callback]) { // 지자체 조회
    console.log('codes actions: ')
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'codes'
    }
    console.log('actions codes axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  search: function (_context, [searchParam, callback]) { // 리스트 조회
    const reqData = {
      spotSeq: searchParam.spotSeq,
      contractStateCodeId: searchParam.contractStateCodeId,
      directYn: String(searchParam.directYn),
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: reqData
    }
    console.log('actions search axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  spotSearch: function (_context, [searchParam, callback]) { // 홈네트워크 현장리스트 조회
    const reqData = {
      spotName: searchParam.spotName,
      pageNum: searchParam.pageNum,
      spotGubun: '홈네트워크',
      rowCount: searchParam.rowCount,
      dongName: searchParam.dongName
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'userSpotList',
      params: reqData
    }
    console.log('actions spotSearch axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  contractCompSearch: function (_context, [searchParam, callback]) { // 계약업체 리스트 조회
    const reqData = {
      contractCompName: searchParam.contractCompName,
      // dongName: searchParam.dongName,
      extraAddress: searchParam.dongName,
      dataFlag: true,
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: '/botw/config/contractComp/search/',
      params: reqData
    }
    console.log('actions contractComp/search/ axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  visitCompSearch: function (_context, [searchParam, callback]) { // 방문업체 리스트 조회
    const reqData = {
      visitCompName: searchParam.visitCompName,
      // dongName: searchParam.dongName,
      extraAddress: searchParam.dongName,
      dataFlag: true,
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: '/botw/config/visitComp/search/',
      params: reqData
    }
    console.log('actions visitComp/search/ axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  consignCompSearch: function (_context, [searchParam, callback]) { // 위탁업체 리스트 조회
    const reqData = {
      consignCompName: searchParam.consignCompName,
      // dongName: searchParam.address,
      extraAddress: searchParam.dongName,
      hnDuruGubun: '홈네트워크',
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: '/botw/config/spot/consignCompSearch',
      params: reqData
    }
    console.log('actions consignCompSearch axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [consignCompSeq, callback]) { // 상세조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail/' + consignCompSeq
    }
    console.log('actions detail/ axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  insert: function (_context, [data, callback]) { // 등록
    const reqData = {
      spotSeq: data.spotSeq,
      contractCode: data.contractCode,
      contractCycle: data.contractCycle,
      contractStateCodeId: data.contractStateCodeId,
      contractEquation: data.contractEquation,
      contractRange: data.contractRange,
      contractPrice: data.contractPrice,
      // monthPrice: data.monthPrice,
      directYn: String(data.directYn),
      applyDate: data.applyDate,
      endDate: data.endDate,
      orderContractCompSeq: data.orderContractCompSeq,
      contractCancelYn: String(data.contractCancelYn),
      consignRangeCodeId: data.consignRangeCodeId,
      consignCompSeq: Number(data.consignCompSeq),
      visitCompSeq: Number(data.visitCompSeq),
      orderContractCompUserSeq: data.orderContractCompUserSeq,
      monthPriceList: data.monthPriceList,
      fileCode: data.tbFile.fileCode
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'insert',
      data: reqData
    }
    console.log('actions insert axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  update: function (_context, [data, callback]) { // 수정
    const reqData = {
      spotSeq: data.spotSeq,
      contractSeq: data.contractSeq,
      contractEquation: data.contractEquation,
      contractCycle: data.contractCycle,
      contractRange: data.contractRange,
      contractPrice: data.contractPrice,
      contractCode: data.contractCode,
      directYn: String(data.directYn),
      applyDate: data.applyDate,
      endDate: data.endDate,
      contractStateCodeId: data.contractStateCodeId,
      orderContractCompSeq: data.orderContractCompSeq,
      contractCancelYn: String(data.contractCancelYn),
      consignRangeCodeId: data.consignRangeCodeId,
      consignCompSeq: Number(data.consignCompSeq),
      visitCompSeq: Number(data.visitCompSeq),
      orderContractCompUserSeq: data.orderContractCompUserSeq,
      monthPriceList: data.monthPriceList,
      fileCode: data.tbFile.fileCode
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'update',
      data: reqData
    }
    console.log('actions update axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descInsert: function (_context, [param, callback]) { // 특이사항 등록
    const reqData = {
      // insertUserSeq: param.insertUserSeq,
      contractSeq: param.contractSeq,
      desc: param.desc
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descInsert',
      data: reqData
    }
    console.log('actions descInsert axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descUpdate: function (_context, [param, callback]) { // 특이사항 수정
    const reqData = {
      updateUserSeq: param.updateUserSeq,
      contractDtlSeq: param.contractDtlSeq,
      contractSeq: param.contractSeq,
      desc: param.desc
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descUpdate',
      data: reqData
    }
    console.log('actions descUpdate axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descDelete: function (_context, [param, callback]) { // 특이사항 삭제
    const reqData = {
      contractSeq: param.contractSeq,
      contractDtlSeq: param.contractDtlSeq
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descDelete',
      data: reqData
    }
    console.log('actions descDelete axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  contractUserList: function (_context, [param, callback]) { // 위탁업체 조회
    const reqData = {
      contractCompSeq: param.contractCompSeq
    }
    const axiosOption = {
      method: 'GET',
      url: '/botw/config/hnContract/contractUserList',
      params: reqData
    }
    console.log('actions contractUserList axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeUpdate: function (_context, [data, callback]) {
    console.log('fileCodeUpdate : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeUpdate',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeInit: function (_context, [data, callback]) {
    console.log('fileCodeInit actions : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeInit',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
